import React from "react";
import { Form } from "semantic-ui-react";
import { useExtLabels } from '../common/extLabels'

const Agreements = ({ model, errors = {}, onChange, disabled, termsAndConditions }) => {
    const l = useExtLabels()

    const handleChange = (name, value) => onChange({ ...model, [name]: value });

    return (
        <React.Fragment>
            <Form.Checkbox
                disabled={disabled}
                label="I want to receive an information about the Performance Marketing Diamonds CEE competition and the gala"
                error={!!errors.notifyAboutCompetition}
                name="notifyAboutCompetition"
                checked={model.notifyAboutCompetition}
                onChange={(target, { name, checked } ) => handleChange(name, checked)}
                required
            />
            <Form.Checkbox
                disabled={disabled}
                label="I want to receive more information about the activities of the e-Chamber of Digital Economy"
                error={!!errors.notifyAboutOtherActivities}
                name="notifyAboutOtherActivities"
                checked={model.notifyAboutOtherActivities}
                onChange={(target, { name, checked } ) => handleChange(name, checked)}
            />
            <Form.Checkbox
                label={<label>I accept <a href={termsAndConditions} target="_blank">the terms and conditions</a></label>}
                disabled={disabled}
                error={!!errors.termsAndConditions}
                name="termsAndConditions"
                checked={model.termsAndConditions}
                onChange={(target, { name, checked } ) => handleChange(name, checked)}
                required
            />
        </React.Fragment>
    );
};

export default Agreements;